import { X } from 'lucide-react';
import type { ReactNode } from 'react';

import { SheetTitle } from '@/shared/components/ui/sheet';

/** 거래처 드로어 공통 헤더 — ✕ · 제목 (M-19 · M-20 · M-22). 아래 줄 내용은 children */
export const DrawerHeader = ({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children?: ReactNode;
}) => (
  <header className="flex shrink-0 flex-col gap-2.5 px-6 pt-[22px]">
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onClose}
        aria-label="닫기"
        className="-m-1 rounded-sm p-1 text-ink-3 outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
      >
        <X className="size-5" />
      </button>
      <SheetTitle className="text-lg leading-7 font-bold text-ink">
        {title}
      </SheetTitle>
    </div>
    {children}
  </header>
);
